export default __webpack_public_path__ + "static/media/home_sensors.be286145.jpg";